<router-outlet></router-outlet>
<div *ngIf="showUIView">
  <div ui-view="layout"></div>
  <div ui-view></div>
</div>
